import React from "react";
import { useSearchParams } from "react-router-dom";
import {
  RemoveSupplyPublicFormSuccessElectricity,
  RemoveSupplyPublicFormSuccessGas,
} from "./RemoveSupplyPublicFormSuccess";
import { getFuelFromParams } from "../../../utils/routeUtils";

const RemoveSupplyPublicFormSuccessWrapper: React.FC = () => {
  const [searchParams] = useSearchParams();
  const fuel = getFuelFromParams(searchParams);

  if (fuel === "gas") {
    return <RemoveSupplyPublicFormSuccessGas />;
  }

  return <RemoveSupplyPublicFormSuccessElectricity />;
};

export default RemoveSupplyPublicFormSuccessWrapper;
